module.exports = __webpack_public_path__ + "static/img/200081.9455f250.png";